import { render, staticRenderFns } from "./VoteEdit.vue?vue&type=template&id=5770b884&"
import script from "./VoteEdit.vue?vue&type=script&lang=js&"
export * from "./VoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports